import React from 'react';
import { Star } from 'lucide-react';

interface Review {
  id: number;
  name: string;
  rating: number;
  comment: string;
  date: string;
}

const reviews: Review[] = [
  {
    id: 1,
    name: "Minh Anh",
    rating: 5,
    comment: "Ứng dụng tuyệt vời để kết nối với hàng xóm. Giao diện đẹp và dễ sử dụng!",
    date: "2 ngày trước"
  },
  {
    id: 2,
    name: "Thanh Hương",
    rating: 5,
    comment: "Rất hữu ích cho việc mua bán trong khu phố. Đã tìm được nhiều món đồ cần thiết.",
    date: "1 tuần trước"
  },
  {
    id: 3,
    name: "Văn Đức",
    rating: 4,
    comment: "App hay, giúp tôi biết thêm nhiều sự kiện thú vị trong khu vực.",
    date: "2 tuần trước"
  }
];

const AppReviews: React.FC = () => {
  return (
    <section className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-black">Đánh giá và nhận xét</h2>
        <div className="flex items-center gap-2">
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className="w-5 h-5 fill-orange-400 text-orange-400"
              />
            ))}
          </div>
          <span className="text-lg font-semibold text-black">4.8</span>
          <span className="text-gray-600">trên 5</span>
        </div>
      </div>
      
      {/* Rating Breakdown */}
      <div className="mb-6">
        {[5, 4, 3, 2, 1].map((rating) => (
          <div key={rating} className="flex items-center gap-3 mb-2">
            <span className="text-sm text-gray-600 w-8">{rating} ⭐</span>
            <div className="flex-1 bg-gray-200 rounded-full h-2">
              <div 
                className="bg-orange-400 h-2 rounded-full"
                style={{ width: rating === 5 ? '75%' : rating === 4 ? '20%' : '5%' }}
              ></div>
            </div>
            <span className="text-sm text-gray-600 w-8">
              {rating === 5 ? '95' : rating === 4 ? '25' : '7'}
            </span>
          </div>
        ))}
      </div>
      
      {/* Individual Reviews */}
      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.id} className="border-b border-gray-100 pb-4 last:border-b-0">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                <span className="text-gray-700 font-semibold text-sm">
                  {review.name.charAt(0)}
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-black">{review.name}</span>
                  <div className="flex items-center">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        className={`w-3 h-3 ${
                          star <= review.rating 
                            ? 'fill-orange-400 text-orange-400' 
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
                <span className="text-xs text-gray-600">{review.date}</span>
              </div>
            </div>
            <p className="text-black text-sm ml-13">{review.comment}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AppReviews;
